(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sib-predictive-search-modal"] && !Shopify.designMode) return;
  try {
    (() => {
    const initPredictiveSearchPanel = () => {
      const trigger = document.querySelector('[data-sib-search-trigger]');
      const panel = document.querySelector('[data-sib-search-panel]');
      if (!trigger || !panel) return;

      const overlay = panel.querySelector('[data-sib-search-overlay]');
      const closeButton = panel.querySelector('[data-sib-search-close]');
      const content = panel.querySelector('[data-sib-search-content]');
      const searchInput = panel.querySelector('.search__input');
      const headerGroupSelector = '.shopify-section-group-sib-header-group';
      const sectionSelector = '.section-sib-top-navbar';
      const getMeasurementTarget = () =>
        trigger.closest(sectionSelector) ||
        panel.closest(sectionSelector) ||
        document.querySelector(sectionSelector) ||
        trigger.closest(headerGroupSelector) ||
        panel.closest(headerGroupSelector) ||
        document.querySelector(headerGroupSelector) ||
        trigger.closest('.sib__top-navbar') ||
        document.querySelector('.sib__top-navbar');
      const setPanelOffsets = () => {
        const target = getMeasurementTarget();
        if (!target) return;
        const rect = target.getBoundingClientRect();
        panel.style.setProperty('--sib-search-top', `${Math.max(rect.top, 0)}px`);
        panel.style.setProperty('--sib-search-left', `${rect.left + rect.width / 2}px`);
        panel.style.setProperty('--sib-search-width', `${rect.width}px`);
        panel.style.setProperty('--sib-search-height', `${rect.height}px`);
      };
      setPanelOffsets();
      let isOpen = false;

      const openPanel = () => {
        if (isOpen) return;
        setPanelOffsets();
        panel.classList.add('is-visible');
        panel.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
        document.body.classList.add('sib-search-open');
        if (typeof trapFocus === 'function' && content) {
          trapFocus(content, searchInput || content);
        } else {
          (searchInput || content)?.focus();
        }
        isOpen = true;
      };

      const closePanel = () => {
        if (!isOpen) return;
        panel.classList.remove('is-visible');
        panel.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('sib-search-open');
        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(trigger);
        } else {
          trigger.focus();
        }
        isOpen = false;
      };

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        if (isOpen) {
          closePanel();
        } else {
          openPanel();
        }
      });

      overlay?.addEventListener('click', closePanel);
      closeButton?.addEventListener('click', closePanel);

      document.addEventListener('keydown', (event) => {
        if (!isOpen) return;
        if (event.key === 'Escape') {
          closePanel();
        }
      });

      window.addEventListener('resize', () => {
        if (isOpen) {
          setPanelOffsets();
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPredictiveSearchPanel);
    } else {
      initPredictiveSearchPanel();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
